// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {

  constructor(
    private service: NgxSpinnerService,
  ) {
  }

  show(name?: string) {
    this.service.show(name);
  }

  hide(name?: string) {
    this.service.hide(name);
  }
}
